<ng-container *transloco="let t; read: 'configuration-entities-component'"
  ><app-configuration-item-editor
    [configuration]="configuration()"
    [configurationLayers]="configurationLayers()"
    [itemTypeTitle]="itemType"
    searchPlaceholder="{{ t('search-placeholder') }}"
    queryPlaceholder="{{ t('query-placeholder') }}"
    queryPropName="name"
    namePropName="normalized"
    syntaxHelpLink="https://semantria-docs.lexalytics.com/docs/entity-configuration"
    [loadItemsApi]="loadItems"
    [createItemApi]="createItem"
    [saveItemApi]="saveItem"
    [deleteItemApi]="deleteItem"
    [deleteAllItemsApi]="deleteAllItems"
    [evaluateItemApi]="evaluateItem"
    [getEvaluationConfigApi]="getEvaluationConfig"
    [getHighlightTextString]="getHighlightText"
    [getEvaluationItemHighlightValue]="getItemHighlightValue"
    [getEvaluationItemByClonedFrom]="getItemByClonedFrom"
    [deleteEvaluationConfigApi]="deleteEvaluationConfig"
    [selectedItemName]="selectedItemName"
    [selectedItemType]="selectedItemType"
    [selectedItemId]="selectedItemId"
    [rowExtraTemplate]="rowData"
    [editorTemplate]="editorData"
    [itemsEditable]="editable"
    [testingEnabled]="canTestItem()"
    [taxonomyItemUsage]="taxonomyItemUsage?.user_entities"
    fragment="entities"
    [addPopoverTemplate]="addButtonTemplate"
    (selectedItemChange)="onItemEditing($event)"
    (itemsLoaded)="onItemsLoaded($event)"
    (saving)="onItemSaving($event)"
    (itemsDeleted)="onItemsDeleted($event)"
    (allItemsDeleted)="onAllItemsDeleted($event)"
    (itemAdded)="onItemAdded($event)"
    (itemUpdated)="onItemUpdated($event)"
  ></app-configuration-item-editor>

  <ng-template #rowData let-item>
    <span>{{ item.type }}</span>
  </ng-template>

  <ng-template #editorData let-item>
    <div class="configuration-entities__type-row">
      <app-lex-autocomplete
        [options]="entityTypes"
        [allowCustom]="true"
        [disabled]="isSaving || !canEditItem()"
        placeholder="{{ t('placeholder') }}"
        inputClass="full-width"
        [labelFormatter]="identityAccessor"
        [optionsFilter]="stringFilter"
        [value]="editingEntity.type"
        (valueChange)="onPropChanged('type', $event)"
      >
        {{ t('type') }}
      </app-lex-autocomplete>
    </div>
  </ng-template>

  <ng-template #addButtonTemplate let-data>
    <p class="configuration-blacklist__add-popover">
      {{ t('no-entry', { data }) }}
    </p>
  </ng-template>
</ng-container>
